import { render } from "./MemberListOverlayCancerforum.vue?vue&type=template&id=244ac8ec"
import script from "./MemberListOverlayCancerforum.vue?vue&type=script&lang=js"
export * from "./MemberListOverlayCancerforum.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__